export type Supplier = 'giga' | 'aosom';

export const SUPPLIER_LABELS: Record<Supplier, string> = {
  giga: 'GIGA',
  aosom: '敖森',
};

export const DEFAULT_SUPPLIER: Supplier = 'giga';

export function isSupplier(value: string | null | undefined): value is Supplier {
  return value === 'giga' || value === 'aosom';
}

export function getSupplierPrefix(supplier: Supplier): string {
  return supplier === 'aosom' ? '/api/aosom' : '/api/giga';
}
